import { UPDATECARD, REMOVECARD } from '../types';
export default {
  namespaced: true,
  state: {
    cardInfo: ''
  },
  mutations: {
    [UPDATECARD] (state, cardInfo) {
      state.cardInfo = Object.assign({}, state.cardInfo, cardInfo);
    },
    [REMOVECARD] (state) {
      state.cardInfo = '';
    }
  },
  actions: {
    updateCard ({ commit }, cardInfo) {
      commit(UPDATECARD, cardInfo);
    },
    removeCard ({ commit }) {
      commit(REMOVECARD);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/card.js